export const updateWorkOrder = /* GraphQL */ `
  mutation UpdateWorkOrder(
    $input: UpdateWorkOrderInput!
    $condition: ModelWorkOrderConditionInput
  ) {
    updateWorkOrder(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      workType
      poNumber
      normalizedPoNumber
      totalUOM
      skipInvoice
      createDateTime
      startDateTime
      endDateTime
      assignedTo
      workflowType
      processedBy
      verificationRequired
      hasException
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      reloadYardId
      inputInventoryId
      areaId
      zoneId
      reloadYardCommodityId
      customFields
      stepName
      updatedAt
    }
  }
`;

export const updateWorkOrderItem = /* GraphQL */ `
  mutation UpdateWorkOrderItem(
    $input: UpdateWorkOrderItemInput!
    $condition: ModelWorkOrderItemConditionInput
  ) {
    updateWorkOrderItem(input: $input, condition: $condition) {
      id
      active
      status
      workOrderId
      sortKey
      poNumber
      quantityToProcess
      units
      accountId
      reloadYardId
      inputInventoryId
      inputInventoryItemId
      updatedAt
    }
  }
`;
